import i18n from '@/common/i18n';

export function yesNoFormatter(val: unknown): string {
  return val ? i18n.t('Yes') : i18n.t('No');
}

export function enabledDisabledFormatter(val: unknown): string {
  return val ? i18n.t('Enabled') : i18n.t('Disabled');
}

export function naLikeFormatter(val: string | undefined | null, naVal: string): string {
  return (val === undefined || val === null || val === '') ? naVal : val;
}

export function naFormatter(val: string | undefined | null): string {
  return naLikeFormatter(val, i18n.t('N/A'));
}

export function dashFormatter(val: string | undefined | null): string {
  return naLikeFormatter(val, i18n.t('figure dash'));
}

export function notSpecifiedFormatter(val: string | undefined | null): string {
  return naLikeFormatter(val, i18n.t('Not specified'));
}

export function conditionalDashFormatter(condition: unknown, val: unknown): unknown {
  return condition ? val : i18n.t('figure dash');
}

export function fullReadonlyFormatter(val: unknown): string {
  if (typeof val === 'boolean') {
    return val ? i18n.t('Full access') : i18n.t('Read only');
  }
  return i18n.t('figure dash');
}
